import { render, staticRenderFns } from "./schemalock.vue?vue&type=template&id=62736ff5&scoped=true&"
import script from "./schemalock.vue?vue&type=script&lang=js&"
export * from "./schemalock.vue?vue&type=script&lang=js&"
import style0 from "./schemalock.vue?vue&type=style&index=0&id=62736ff5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62736ff5",
  null
  
)

export default component.exports